export default {
  duration: 800,
  smooth: true,
  offset: -150,
};
